module.exports = __webpack_public_path__ + "static/media/dashboard-workspace-app-application-layout-vertical.5efcc7bc.svg";